var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2349_24634",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "currentColor",
    clipRule: "currentColor",
    d: "M6.66675 10C6.66675 9.53978 7.03984 9.16669 7.50008 9.16669L15.4876 9.16669L14.4108 8.08928C14.1104 7.78887 14.0873 7.31618 14.3415 6.98927L14.4108 6.91077C14.7112 6.61036 15.1839 6.58725 15.5108 6.84144L15.5893 6.91077L18.0893 9.41077L18.1238 9.4474L18.1698 9.50393L18.2295 9.59664L18.2741 9.69057L18.3035 9.77836L18.3277 9.90213L18.3334 10L18.3311 10.0627L18.3165 10.1673L18.292 10.2601L18.2554 10.3527L18.2118 10.4339L18.1561 10.514C18.1354 10.5404 18.1131 10.5656 18.0893 10.5893L15.5893 13.0893C15.2639 13.4147 14.7363 13.4147 14.4108 13.0893C14.1104 12.7889 14.0873 12.3162 14.3415 11.9893L14.4108 11.9108L15.4876 10.8334L7.50008 10.8334C7.03984 10.8334 6.66675 10.4603 6.66675 10ZM10.0001 17.5C10.0001 17.9274 9.67838 18.2796 9.26393 18.3277L9.16675 18.3334H4.16675C2.83535 18.3334 1.74703 17.2926 1.67099 15.9802L1.66675 15.8334L1.66675 4.16669C1.66675 2.83529 2.70752 1.74697 4.01985 1.67093L4.16675 1.66669L9.16675 1.66669C9.62699 1.66669 10.0001 2.03978 10.0001 2.50002C10.0001 2.92738 9.67838 3.27961 9.26393 3.32775L9.16675 3.33335L4.16675 3.33335C3.73939 3.33335 3.38716 3.65505 3.33902 4.0695L3.33342 4.16669L3.33341 15.8334C3.33341 16.2607 3.65512 16.6129 4.06956 16.6611L4.16675 16.6667H9.16675C9.62699 16.6667 10.0001 17.0398 10.0001 17.5Z",
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2349_24634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.888015bd.svg";
export { ForwardRef as ReactComponent };